export default {
    form(state) {
        return state.form;
    },
};
